






















































































































































































import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ChangeRatePlanEvent,
  RatePlanModel,
  ReservationAccUnitModel,
  ReservationModel,
  SelectedRatePlanModel,
} from "./types";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import { Getter } from "vuex-class";
import { FinancialSettingsType } from "@/store/modules/financial";
import { DateTime } from "luxon";
import { ServiceType } from "@/shared/models/serviceType";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import * as _ from "lodash";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import { differenceInYears, getAge } from "@/shared/dateFormatUtils";
import {
  getUnitOwnerIds,
  calculateAddOnServiceQuantity,
  addOnServiceNeedsRange,
} from "./functions";
import { AddOnServiceModel } from "./types";
import { TaxRateView } from "@/shared/models/taxRates";
import {
  AccomodationUnitStatusEnum,
  DistributionChannelEnum,
  PriceCalculationMethodsEnum,
} from "@/shared/models/enums.type";
import { CalculationMethods } from "@/shared/models/priceCalculationMethods";
import { reservationStatuses } from "@/shared/models/vReservation";
import NumericPicker from "@/components/misc/NumericPicker.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import TimeField from "@/components/misc/TimeField.vue";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import { round } from "@/components/numbers/numberFormatUtils";

@Component({
  components: {
    NumericInputImproved,
    CurrencyDisplay,
    NumericPicker,
    FormDescription,
    TimeField,
  },
})
export default class ReservationFormUnitTileMobile extends Vue {
  @PropSync("reservation") reservationModel?: ReservationModel;
  @PropSync("overbooked") isOverbooked?: number[];
  @PropSync("notAvailable") isNotAvailable?: number[];
  @PropSync("unit", { default: undefined }) model?: ReservationAccUnitModel;
  @Prop({ default: true }) isEditingReservation?: boolean;
  @Prop() serviceTypes?: ServiceType[];
  @Getter("financial/settings") financialSettings?: FinancialSettingsType;

  currencyConversionService?: CurrencyConversionService;
  async created() {
    if (this.financialSettings && this.currencyConversionService == undefined) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }
  }

  @Watch("model.channelCommission")
  async updateInputPriceIfThereIsChannelCommission(fresh: number, old: number) {
    if (fresh !== old) {
      const numberOfNights = this.numberOfNights;
      const commissionPerNight = round(fresh / this.numberOfNights);
      const previousCommissionPerNight = round(old / numberOfNights);
      const normalizedValue = this.model?.channelCommissionPercent ?? 0;

      // Calculate initial input price
      if (
        this.model?.dayPrices.every(
          (x) => x.inputPrice === x.inputPriceBeforeCommission
        ) &&
        normalizedValue > 0
      ) {
        this.model.dayPrices.forEach((x) => {
          x.inputPrice = x.inputPriceBeforeCommission - commissionPerNight;
        });
      }

      // Calculate input price if commission was changed.
      else if (
        this.model?.dayPrices.every(
          (x) =>
            x.inputPrice ===
            x.inputPriceBeforeCommission - previousCommissionPerNight
        )
      ) {
        this.model.dayPrices.forEach((x) => {
          x.inputPrice = x.inputPriceBeforeCommission - commissionPerNight;
        });
      }
    }
  }

  @Getter("auth/claims") claims?: JwtClaims;
  get canEditPrices() {
    return (
      policyChecker("MODIFY_RESERVATION_PRICES")(this.claims) ||
      (policyChecker("OWNER_LEVEL_3")(this.claims) &&
        this.reservationModel?.distributionChannelTypeId ===
          DistributionChannelEnum.OwnersReservation)
    );
  }

  get showUnitStatus() {
    return policyChecker("UNIT_STATUS")(this.claims);
  }

  get reservationIsReadonly() {
    if (
      (policyChecker("OWNER_LEVEL_3")(this.claims) &&
        this.reservationModel?.distributionChannelTypeId ===
          DistributionChannelEnum.OwnersReservation) ||
      !policyChecker("OWNER_LEVEL_3")(this.claims)
    ) {
      return false;
    }
    return true;
  }

  get isOwnerLevel3() {
    return policyChecker("OWNER_LEVEL_3")(this.claims);
  }

  updateChildren() {
    if (this.model) {
      if (!this.model.numberOfChildren || this.model.numberOfChildren <= 0) {
        this.model.childrenAges = [];
        return;
      }

      while (this.model.childrenAges.length < this.model.numberOfChildren) {
        this.model.childrenAges.push(0);
      }

      while (this.model.childrenAges.length > this.model.numberOfChildren) {
        this.model.childrenAges.pop();
      }
    }
  }

  get warnings() {
    const warnings = [] as string[];

    if (this.model?.numberOfAdults == 0 && this.model?.numberOfChildren == 0) {
      warnings.push("Reservation.Warning.UnitNoGuestsSet");
    }

    if (this.model?.selectedServices.some((x) => x.decimalQuantity == 0)) {
      warnings.push("Reservation.Warning.UnitAddOnServiceQuantity0");
    }

    if (
      this.model?.accomodationUnitId &&
      this.isOverbooked?.includes(this.model?.accomodationUnitId)
    ) {
      warnings.push("AccommodationUnit.Overbooked");
    }

    if (
      this.model?.accomodationUnitId &&
      this.isNotAvailable?.includes(this.model?.accomodationUnitId)
    ) {
      warnings.push("Reservation.Warning.UnitNotAvailable");
    }

    return warnings;
  }

  get errors() {
    const errors = [] as string[];

    if (!this.model?.ratePlan?.id) {
      errors.push("Reservation.Error.UnitRatePlanMustMeSelected");
    }

    if (
      this.model?.childrenAges.some(
        (x) => x == undefined || x == null || x.toString() == "" || x < 0
      )
    ) {
      errors.push("Reservation.Error.UnitAllChildrenAgesMustBeSet");
    }

    if (
      this.model &&
      (this.model?.numberOfAdults < 0 || this.model?.numberOfChildren < 0)
    ) {
      errors.push("Reservation.Error.GuestValuaCannotBeNegative");
    }

    // owner's reservation checks
    // unit must have an owner
    if (
      this.reservationModel &&
      this.reservationModel.distributionChannelTypeId ===
        DistributionChannelEnum.OwnersReservation &&
      this.model &&
      getUnitOwnerIds(this.model).length === 0
    ) {
      errors.push(
        "Reservation.OwnersReservation.Validation.UnitsMustHaveAnOwner"
      );
    }

    // all units on the reservation must have the same owner
    if (
      this.reservationModel &&
      this.reservationModel.distributionChannelTypeId ===
        DistributionChannelEnum.OwnersReservation &&
      this.model &&
      this.hasCommonOwner
    ) {
      errors.push(
        "Reservation.OwnersReservation.Validation.UnitsMustHaveSameOwner"
      );
    }

    return errors;
  }

  get hasCommonOwner() {
    if (!this.reservationModel || !this.model) return false;

    const allUnits = this.reservationModel.accomodationUnitTypes;
    const allOwners = _.uniq(allUnits.flatMap((x) => getUnitOwnerIds(x)));

    const unitsByOwner = [] as {
      ownerId: number;
      units: ReservationAccUnitModel[];
    }[];
    allOwners.forEach((x) => {
      unitsByOwner.push({
        ownerId: x,
        units: allUnits.filter((e) => getUnitOwnerIds(e).includes(x)),
      });
    });

    return unitsByOwner.some(
      (o) => !allUnits.some((e) => !o.units.includes(e))
    );
  }

  get unitCurrencyId() {
    return (
      this.model?.ratePlan?.currencyId ??
      this.financialSettings?.workingCurrency.id
    );
  }

  get servicesPrice() {
    const isAllowedOnlyInputPrices = policyChecker("INPUT_PRICES")(this.claims);
    if (this.model && this.model.selectedServices) {
      if (!isAllowedOnlyInputPrices) {
        return this.model.selectedServices.reduce(
          (sum, e) =>
            e.currencyId == this.financialSettings?.formalCurrency.id
              ? sum +
                round(e.grossPrice *
                  this.financialSettings.formalToWorkingConversionRate)
              : sum + e.grossPrice,
          0
        );
      } else {
        return this.model.ownerAddOnServicesPrice ?? 0;
      }
    } else {
      return 0;
    }
  }

  get totalPrice() {
    const totalServicesPrice = this.servicesPrice;
    let totalDayPrices = 0;

    if (this.model && this.model.dayPrices) {
      totalDayPrices = this.model.dayPrices.reduce(
        (sum, e) => sum + e.price,
        0
      );
    }

    if (this.model && this.model.discountPercent) {
      totalDayPrices = round(totalDayPrices * (1 - this.model.discountPercent / 100));
    }

    return totalDayPrices + totalServicesPrice;
  }

  get numberOfNights() {
    if (this.model?.arrivalDate && this.model?.departureDate) {
      const numberOfNights = this.differenceInDays(
        new Date(this.model.arrivalDate),
        new Date(this.model.departureDate)
      );
      return isFinite(numberOfNights) && numberOfNights > 0
        ? numberOfNights
        : 1;
    } else {
      return 0;
    }
  }

  differenceInDays(date1: Date, date2: Date) {
    const d1 = DateTime.fromJSDate(date1).set({ hour: 0 });
    const d2 = DateTime.fromJSDate(date2).set({ hour: 0 });
    const diff = d2.diff(d1, ["days"]).days;
    return diff;
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      age: (value: number) =>
        ((!!value || value === 0) && value >= 0 && value % 1 == 0) ||
        this.$t("Reservation.ChildAgeMustBeWholePositiveNumber"),
      mustBeWholeNumber: (value: number) =>
        value == null ||
        value == undefined ||
        value % 1 == 0 ||
        this.$t("Validation.MustBeWholeNumber"),
      mustBePositive: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
    };
  }

  countDecimals(num: number) {
    return num?.toString().split(".")[1]?.length || 0;
  }

  pricePerNightInput() {
    if (this.model) {
      this.model.userSetPricePerNightManually = true;
      this.model.manuallyChangedRatePlan = true; // lock rate plan so user doesn't change price by accident (ex: changing adults)
      this.model.dayPrices.forEach(
        (x) => (
          (x.price =
            (this.model?.pricePerNight ?? 0) - this.mergedCityTaxPricePerDay),
          (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay)
        )
      );
      //if owner level 3 is changing prices manually, all prices should be the same
      if (this.isOwnerLevel3) {
        this.model.dayPrices.forEach(
          (x) =>
            (x.inputPrice =
              (this.model?.pricePerNight ?? 0) - this.mergedCityTaxPricePerDay)
        );
      }
    }
  }

  get mergedCityTaxPricePerDay() {
    let totalCityTaxPrice = 0;
    if (this.model && this.model.selectedServices) {
      totalCityTaxPrice =
        this.model.selectedServices
          .filter((x) => x.isCityTax)
          .reduce(
            (sum, e) =>
              this.serviceTypes?.find(
                (x) => x.id == _.first(this.model?.dayPrices)?.serviceTypeId
              )?.includesCityTax === true
                ? sum +
                  (this.currencyConversionService?.convertCurrency(
                    e.grossPrice,
                    e.currencyId,
                    this.unitCurrencyId ?? e.currencyId
                  ) ?? e.grossPrice)
                : sum,
            0
          ) || 0;
    }

    return (
      round(totalCityTaxPrice / (this.numberOfNights > 0 ? this.numberOfNights : 1))
    );
  }

  /**
   * below is pretty much a c/p from ReservationFormAddOnServices.vue to support recalculating
   * AOS amounts/quantities/periods on mobile as well as they're completely hidden and the relevant
   * component where it all gets automatically recalculated is not present on mobile
   */
  get addOnServiceQuantityFactors() {
    const stringToday = new Date().toISOString().substring(0, 10);

    return {
      numberOfDays:
        this.model?.arrivalDate && this.model?.departureDate
          ? this.differenceInDays(
              new Date(this.model.arrivalDate),
              new Date(this.model.departureDate)
            )
          : 0,
      numberOfAdults: this.model?.numberOfAdults ?? 0,
      numberOfNonTaxableAdults: this.model?.guests.filter(
        (x) =>
          x.city === this.model?.city &&
          (!x.dateOfBirth ||
            Math.floor(
              differenceInYears(
                new Date(x.dateOfBirth as string),
                new Date(stringToday)
              )
            ) >= 18)
      ).length,
      numberOfChildren: this.model?.numberOfChildren ?? 0,
      numberOfTaxableChildren:
        this.model?.childrenAges.filter((x) => x > 11 && x < 18).length ?? 0,
      unitStayDates: [
        this.model?.arrivalDate.substring(0, 10),
        this.model?.departureDate.substring(0, 10),
      ],
    };
  }

  reAddCityTax = true;
  @Getter("appParams/calculateWithEVisitorDates")
  calculateWithEVisitorDates?: boolean;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];

  needsRange(item: AddOnServiceModel) {
    return addOnServiceNeedsRange(item.calculationMethodId);
  }

  // this functions readds all services when factors change
  @Watch("addOnServiceQuantityFactors", { deep: true })
  addOnServiceQuantityFactorsChanged(fresh: any, old: any) {
    if (this.model && !_.isEqual(fresh, old)) {
      const unit = this.model;

      if (!unit.selectedServices.some((x) => x.isCityTax)) {
        this.reAddCityTax = false;
      }

      // select cityTax categories which have a tax edited to add later
      const calculationMethodIds = unit.selectedServices
        .filter(
          (x) =>
            !this.calculateWithEVisitorDates &&
            x.isCityTax &&
            x.isEditedManually
        )
        .map((x) => x.calculationMethodId);
      const manuallyEditedServices = unit.selectedServices.filter(
        (x) =>
          x.isCityTax && calculationMethodIds.includes(x.calculationMethodId)
      );

      // select non city taxes to recalculate
      unit.selectedServices = unit.selectedServices.filter((x) => !x.isCityTax);

      //automatically adjust start/end date on services that had the full length
      //of stay period for their period - if the number of days has changed
      if (fresh.numberOfDays !== old.numberOfDays) {
        unit.selectedServices.forEach((service) => {
          if (addOnServiceNeedsRange(service.calculationMethodId)) {
            //basically check if service had the same from-to
            //dates as the "old" from-to dates were on the unit
            //if so, automatically adjust service dates from-to
            //to new unit dates from-to so new calculation method
            //which works on AOS from-to behaves as expected on unit stay change
            if (
              fresh.unitStayDates.length == 2 &&
              old.unitStayDates.length == 2 &&
              service.serviceDateFrom == old.unitStayDates[0].substr(0, 10) &&
              service.serviceDateTo == old.unitStayDates[1].substr(0, 10)
            ) {
              service.serviceDateFrom = fresh.unitStayDates[0].substr(0, 10);
              service.serviceDateTo = fresh.unitStayDates[1].substr(0, 10);
            }
          }
        });
      }

      unit.selectedServices.forEach((service) => {
        if (
          service.pricesAreSeasonal &&
          old.numberOfDays !== fresh.numberOfDays &&
          this.needsRange(service)
        ) {
          this.addSeasonalAOS(service, true);
        } else {
          calculateAddOnServiceQuantity(
            service,
            unit,
            this.calculateWithEVisitorDates ?? false
          );
        }
        this.setGrossPrice(service);
      });

      // add modified cityTaxes
      unit.selectedServices.push(...manuallyEditedServices);

      if (calculationMethodIds.length > 0) {
        unit.selectedServices = this.removeZeroQuantityCityTax(
          unit.selectedServices
        );
      }

      const services: AddOnServiceModel[] = [];
      const availableTaxes = _.cloneDeep(
        unit.availableServices.filter((x) => x.isCityTax && this.reAddCityTax)
      );

      // selecting from available taxes if factors dictate
      if (
        !calculationMethodIds.includes(
          PriceCalculationMethodsEnum.PerAdultPerNight
        )
      ) {
        if (
          this.addOnServiceQuantityFactors.numberOfAdults > 0 ||
          (this.calculateWithEVisitorDates &&
            (unit.guests.some(
              (x) => getAge(x.dateOfBirth ?? new Date()) >= 18
            ) ||
              unit.guests.some((x) => x.dateOfBirth === undefined)))
        ) {
          services.push(
            ...availableTaxes.filter(
              (x) =>
                x.calculationMethodId ==
                PriceCalculationMethodsEnum.PerAdultPerNight
            )
          );
        }
      }
      if (
        !calculationMethodIds.includes(
          PriceCalculationMethodsEnum.PerChildPerNight
        )
      ) {
        if (
          this.addOnServiceQuantityFactors.numberOfTaxableChildren > 0 ||
          (this.calculateWithEVisitorDates &&
            unit.guests.some(
              (x) =>
                getAge(x.dateOfBirth ?? new Date()) > 11 &&
                getAge(x.dateOfBirth ?? new Date()) < 18
            ))
        ) {
          services.push(
            ...availableTaxes.filter(
              (x) =>
                x.calculationMethodId ==
                PriceCalculationMethodsEnum.PerChildPerNight
            )
          );
        }
      }

      // no services exist add those that are added automatically
      if (calculationMethodIds.length == 0 && services.length === 0) {
        const s = _.cloneDeep(
          this.model.availableServices.filter(
            (x) => x.isCityTax && x.isAddedAutomatically && this.reAddCityTax
          )
        );
        services.push(...s);
      }

      // when using this function it calculates for all the factors including date dependent city tax price
      this.add(services);
    }
  }

  serviceQuantityEdited: number[] = [];
  selectedToAdd: AddOnServiceModel[] = [];
  add(selected: AddOnServiceModel[]) {
    if (this.model && this.reservationModel) {
      let toAdd: AddOnServiceModel[] = [];
      for (const service of selected) {
        toAdd.push(service);
        if (
          service.periods &&
          service.periods.length != 0 &&
          !service.isEditedManually
        ) {
          toAdd = toAdd.concat(
            service.periods.map((x) => {
              return {
                ...service,
                netUnitPrice: x.amount,
                from: x.from,
                to: x.to,
                serviceDateFrom: x.from,
                serviceDateTo: x.to,
                periods: [],
              } as AddOnServiceModel;
            })
          );
        }
      }

      for (const service of toAdd) {
        if (!this.serviceQuantityEdited.includes(service.addOnServiceId)) {
          calculateAddOnServiceQuantity(
            service,
            this.model,
            this.calculateWithEVisitorDates ?? false
          );
        }
        this.setGrossPrice(service);
      }

      toAdd = this.removeZeroQuantityCityTax(toAdd);

      this.adjustPeriodizedItems(
        toAdd.filter(
          (x) =>
            x.isCityTax &&
            x.calculationMethodId == CalculationMethods.PerAdultPerNight
        )
      );
      this.adjustPeriodizedItems(
        toAdd.filter(
          (x) =>
            x.isCityTax &&
            x.calculationMethodId == CalculationMethods.PerChildPerNight
        )
      );

      this.model.selectedServices.push(...toAdd);
      this.$emit("servicesListChanged");
      this.serviceQuantityEdited = [];
      this.selectedToAdd = [];
    }
  }

  addSeasonalAOS(item: AddOnServiceModel, reAddSeasonPrices: boolean) {
    if (this.model && this.reservationModel) {
      const itemToAdd = _.cloneDeep(item);
      itemToAdd.id = 0;

      if (itemToAdd.decimalQuantity != this.getDefaultQuantity(itemToAdd)) {
        //flag item as edited manually only if user changed the quantity manually when selecting
        //to avoid recalculating quantity automatically in such cases
        itemToAdd.isEditedManually = true;
      }

      itemToAdd.serviceDateFrom = this.model?.arrivalDate ?? "";
      itemToAdd.serviceDateTo = this.model?.departureDate ?? "";
      itemToAdd.serviceRange = [
        itemToAdd.serviceDateFrom,
        itemToAdd.serviceDateTo,
      ];

      //remove selected seasonal prices
      //reset 'first' date so the behaviour is the same as adding seasonal AOS for the first time
      if (reAddSeasonPrices) {
        this.model.selectedServices = this.model.selectedServices.filter(
          (x) => x.addOnServiceId !== item.addOnServiceId
        );
        itemToAdd.from = "";
        itemToAdd.to = "";
      }

      let itemsToAdd: AddOnServiceModel[] = [];

      if (itemToAdd.isCityTax || itemToAdd.pricesAreSeasonal) {
        itemToAdd.isEditedManually = false;

        switch (itemToAdd.calculationMethodId) {
          case PriceCalculationMethodsEnum.PerAdultPerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerChildPerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerPersonPerNight:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
          case PriceCalculationMethodsEnum.PerDay:
            itemsToAdd = this.periodizeService(itemToAdd);
            break;
        }
      }

      if (itemsToAdd && itemsToAdd.length > 0) {
        this.model.selectedServices.push(...itemsToAdd);
      } else {
        this.model.selectedServices.push(itemToAdd);
      }

      this.$emit("servicesListChanged");
    }
  }

  periodizeService(service: AddOnServiceModel) {
    let toAdd: AddOnServiceModel[] = [];

    if (this.model) {
      toAdd.push(service);
      if (service.periods && service.periods.length > 0) {
        toAdd = toAdd.concat(
          service.periods.map((x) => {
            return {
              ...service,
              netUnitPrice: x.amount,
              from: x.from.substring(0, 10),
              to: x.to.substring(0, 10),
              serviceDateFrom: x.from.substring(0, 10),
              serviceDateTo: x.to.substring(0, 10),
              periods: service.periods,
            } as AddOnServiceModel;
          })
        );
      }

      for (const service of toAdd) {
        calculateAddOnServiceQuantity(
          service,
          this.model,
          this.calculateWithEVisitorDates ?? false
        );
        this.setGrossPrice(service);
      }

      toAdd = toAdd.filter((x) => x.decimalQuantity > 0);

      if (service.pricesAreSeasonal) {
        this.adjustPeriodizedItems(toAdd);
      } else {
        this.adjustPeriodizedItems(toAdd);
      }
    }

    return toAdd;
  }

  adjustPeriodizedItems(items: AddOnServiceModel[]) {
    if (this.model) {
      if (items.length > 0) {
        const nonPeriodizedItem = items.find((x) => !x.from && !x.to);

        if (!nonPeriodizedItem) {
          const dates = this.determineDate(items[0]);
          items[0].serviceDateFrom = dates?.minDate ?? this.model.arrivalDate;
          this.setItemRange(items[0]);

          items[items.length - 1].serviceDateTo =
            dates?.maxDate ?? this.model.departureDate;
          this.setItemRange(items[items.length - 1]);
        } else {
          const periodizedItem = items.find((x) => x != nonPeriodizedItem);

          if (periodizedItem) {
            const periodizedStartInUnitStayDate =
              this.model.arrivalDate <= periodizedItem.from &&
              periodizedItem.from <= this.model.departureDate;
            const periodizedEndInUnitStayDate =
              this.model.arrivalDate <= periodizedItem.to &&
              periodizedItem.to <= this.model.departureDate;

            if (periodizedStartInUnitStayDate) {
              const dates = this.determineDate(nonPeriodizedItem);
              //periodized item is after the default
              periodizedItem.serviceDateTo =
                dates?.maxDate ?? this.model.departureDate;
              this.setItemRange(periodizedItem);

              nonPeriodizedItem.serviceDateFrom =
                dates?.minDate ?? this.model.arrivalDate;
              nonPeriodizedItem.serviceDateTo = DateTime.fromISO(
                periodizedItem.serviceDateFrom ?? ""
              )
                .plus({ days: -1 })
                .toISO()
                .substr(0, 10);
              this.setItemRange(nonPeriodizedItem);
            }

            if (periodizedEndInUnitStayDate) {
              const dates = this.determineDate(periodizedItem);
              //periodized item is before the default
              periodizedItem.serviceDateFrom =
                dates?.minDate ?? this.model.arrivalDate;
              this.setItemRange(periodizedItem);

              nonPeriodizedItem.serviceDateFrom = DateTime.fromISO(
                periodizedItem.serviceDateTo ?? ""
              )
                .plus({ days: 1 })
                .toISO()
                .substr(0, 10);
              nonPeriodizedItem.serviceDateTo =
                dates?.maxDate ?? this.model.departureDate;
              this.setItemRange(nonPeriodizedItem);
            }
          } else {
            const dates = this.determineDate(items[0]);
            items[0].serviceDateFrom = dates?.minDate ?? this.model.arrivalDate;
            this.setItemRange(items[0]);

            items[items.length - 1].serviceDateTo =
              dates?.maxDate ?? this.model.departureDate;
            this.setItemRange(items[items.length - 1]);
          }
        }
      }
    }
  }

  determineDate(item: AddOnServiceModel) {
    if (this.calculateWithEVisitorDates && item.isCityTax) {
      if (
        this.nonLocalAdultGuestCheckInDates.length > 0 ||
        this.nonLocalChildrenGuestCheckInDates.length > 0 ||
        this.nonLocalAdultGuestCheckOutDates.length > 0 ||
        this.nonLocalChildrenGuestCheckOutDates.length > 0
      ) {
        let minDate = null;
        let maxDate = null;

        if (item.calculationMethodId == CalculationMethods.PerAdultPerNight) {
          minDate = this.nonLocalAdultGuestCheckInDates.reduce((x, y) =>
            x < y ? x : y
          );
          maxDate = this.nonLocalAdultGuestCheckOutDates.reduce((x, y) =>
            x > y ? x : y
          );
        }

        if (item.calculationMethodId == CalculationMethods.PerChildPerNight) {
          minDate = this.nonLocalChildrenGuestCheckInDates.reduce((x, y) =>
            x < y ? x : y
          );
          maxDate = this.nonLocalChildrenGuestCheckOutDates.reduce((x, y) =>
            x > y ? x : y
          );
        }

        if (minDate) {
          //account for timezone offset since the date is in browser local timezone
          minDate.setHours(
            minDate.getHours() - minDate.getTimezoneOffset() / 60
          );
        }

        if (maxDate) {
          //account for timezone offset since the date is in browser local timezone
          maxDate.setHours(
            maxDate.getHours() - maxDate.getTimezoneOffset() / 60
          );
        }

        return {
          minDate: minDate
            ? minDate.toISOString().substr(0, 10)
            : this.model?.arrivalDate ?? "",
          maxDate: maxDate
            ? maxDate.toISOString().substr(0, 10)
            : this.model?.departureDate ?? "",
        };
      } else {
        return {
          minDate: this.model?.arrivalDate ?? "",
          maxDate: this.model?.departureDate ?? "",
        };
      }
    }
  }

  get nonLocalAdultGuestCheckInDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            (!x.dateOfBirth || getAge(x.dateOfBirth) >= 18) &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(x.eVisitorCheckInDate ?? this.model?.arrivalDate ?? "") ??
            new Date(this.model?.arrivalDate ?? "")
        );
    }

    return [];
  }

  get nonLocalChildrenGuestCheckInDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            x.dateOfBirth &&
            getAge(x.dateOfBirth) < 18 &&
            getAge(x.dateOfBirth) >= 12 &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(x.eVisitorCheckInDate ?? this.model?.arrivalDate ?? "") ??
            new Date(this.model?.arrivalDate ?? "")
        );
    }

    return [];
  }

  get nonLocalAdultGuestCheckOutDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            (!x.dateOfBirth || getAge(x.dateOfBirth) >= 18) &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(
              (x.isEVisitorCheckedOut
                ? x.eVisitorCheckOutDate
                : x.checkOutDate) ??
                this.model?.departureDate ??
                ""
            ) ?? new Date(this.model?.departureDate ?? "")
        );
    }

    return [];
  }

  get nonLocalChildrenGuestCheckOutDates() {
    if (this.model) {
      return this.model.guests
        .filter(
          (x) =>
            x.city !== this.model?.city &&
            x.dateOfBirth &&
            getAge(x.dateOfBirth) < 18 &&
            getAge(x.dateOfBirth) >= 12 &&
            x.isEVisitorCheckedIn
        )
        .map(
          (x) =>
            new Date(
              (x.isEVisitorCheckedOut
                ? x.eVisitorCheckOutDate
                : x.checkOutDate) ??
                this.model?.departureDate ??
                ""
            ) ?? new Date(this.model?.departureDate ?? "")
        );
    }

    return [];
  }

  seasonalPricesQuantityForAOSRange(item: AddOnServiceModel) {
    if (item.serviceDateFrom && item.serviceDateTo && this.model) {
      const numberOfNights = this.differenceInDays(
        new Date(item.serviceDateFrom),
        new Date(item.serviceDateTo)
      );
      switch (item.calculationMethodId) {
        case CalculationMethods.PerStay: {
          item.quantity = item.decimalQuantity = 1;
          break;
        }
        case CalculationMethods.PerNight: {
          item.quantity = item.decimalQuantity = numberOfNights;
          break;
        }
        case CalculationMethods.PerPersonPerNight: {
          item.quantity = item.decimalQuantity =
            numberOfNights *
            (this.model.numberOfAdults + this.model.numberOfChildren);
          break;
        }
        case CalculationMethods.PerPerson: {
          item.quantity = item.decimalQuantity =
            this.model.numberOfAdults + this.model.numberOfChildren;
          break;
        }
        case CalculationMethods.PerAdultPerson: {
          item.quantity = item.decimalQuantity = this.model.numberOfAdults;
          break;
        }
        case CalculationMethods.PerChildPerNight: {
          item.quantity = item.decimalQuantity =
            numberOfNights * this.model.numberOfChildren;
          break;
        }
        case CalculationMethods.PerAdultPerNight: {
          item.quantity = item.decimalQuantity =
            numberOfNights * this.model.numberOfAdults;
          break;
        }

        case CalculationMethods.PerDay: {
          item.quantity = item.decimalQuantity = numberOfNights + 1;
          break;
        }
      }
    }
  }

  setItemRange(item: AddOnServiceModel) {
    item.serviceRange = [item.serviceDateFrom, item.serviceDateTo];
  }

  setGrossPrice(item: AddOnServiceModel) {
    const taxRateFactor = round((this.taxRates?.find(e => e.id === item.taxRateId)?.rate ?? 0) / 100, 4);
    const discountFactor = item.discountPercent ? round(item.discountPercent / 100, 6) : 0;

    let grossPrice = round(round(item.grossUnitPrice * item.decimalQuantity, 2) * (1 - discountFactor), 2);
    let netPrice = round(grossPrice / (1 + taxRateFactor), 2);

    if (item.pricesAreSeasonal) {
      if (!item.from && !item.to) {
        const today = new Date().toISOString().substring(0, 10);
        const period = item.periods.find(
          (x) =>
            today >= x.from.substring(0, 10) && today <= x.to.substring(0, 10)
        );
        item.grossUnitPrice = period?.amount ?? 0;
        grossPrice =  period ? round(round(period.amount * item.decimalQuantity, 2) * (1 - discountFactor), 2) : grossPrice;
        netPrice = period ? round(round(period.amount / ( 1 + taxRateFactor), 2) * item.decimalQuantity, 2) : netPrice;

        item.netUnitPrice = round(item.grossUnitPrice / (1 + taxRateFactor), 2);
      } else if (item.id > 0) {
        item.netUnitPrice = round(item.grossUnitPrice / (1 + taxRateFactor), 2);
      } else {
        const period = item.periods.find(
          (x) =>
            x.from.substring(0, 10) == item.from && x.to.substring(0, 10) == item.to
        );
        grossPrice = period ? round(round(period.amount * item.decimalQuantity, 2) * (1 - discountFactor), 2) : grossPrice;
        netPrice = period ? round(round(period.amount / ( 1 + taxRateFactor), 2) * item.decimalQuantity, 2) : netPrice;
        item.grossUnitPrice = period?.amount ?? 0;
        item.netUnitPrice = period ? round(period.amount / (1 + taxRateFactor), 2) : netPrice;
      }
    }

    item.grossPrice = grossPrice;
    return item.grossPrice;
  }

  removeZeroQuantityCityTax(toAdd: AddOnServiceModel[]) {
    const temp = _.clone(toAdd.filter((x) => x.isCityTax));
    for (const service of temp) {
      if (service.to && service.from && service.decimalQuantity === 0) {
        toAdd = toAdd.filter((x) => !_.isEqual(service, x));
      } else if (
        !service.to &&
        !service.from &&
        service.decimalQuantity === 0 &&
        toAdd.some(
          (x) =>
            x.addOnServiceId === service.addOnServiceId &&
            x.decimalQuantity != 0
        )
      ) {
        toAdd = toAdd.filter((x) => !_.isEqual(service, x));
      }
    }

    return toAdd;
  }

  getDefaultQuantity(item: AddOnServiceModel) {
    const stayLength = this.differenceInDays(
      new Date(this.model?.arrivalDate ?? ""),
      new Date(this.model?.departureDate ?? "")
    );
    const numAdults = this.model?.numberOfAdults ?? 0;
    const numChildren = this.model?.numberOfChildren ?? 0;
    const numTaxableChildren =
      this.model?.childrenAges.filter((x) => x > 11 && x < 18).length ?? 0;
    const numPersons = numAdults + numChildren;

    //sensible defaults for quantities
    switch (item.calculationMethodId) {
      case CalculationMethods.PerStay:
        return 1;
      case CalculationMethods.PerNight:
        return stayLength;
      case CalculationMethods.PerPersonPerNight:
        return numPersons * stayLength;
      case CalculationMethods.PerPerson:
        return numPersons;
      case CalculationMethods.PerAdultPerson:
        return numAdults;
      case CalculationMethods.PerAdultPerNight:
        return numAdults * stayLength;
      case CalculationMethods.PerChildPerNight:
        return item.isCityTax
          ? numTaxableChildren * stayLength
          : numChildren * stayLength;
      case CalculationMethods.Manual:
        return 0;
      case CalculationMethods.PerDay:
        return stayLength + 1;
      default:
        return 0;
    }
  }

  get unitStatus() {
    return reservationStatuses.find((x) => x.id == this.model?.statusId);
  }

  get showStatusIcon() {
    if (this.model?.accomodationUnitStatus) {
      return (
        this.model.accomodationUnitStatus != AccomodationUnitStatusEnum.Clean
      );
    }
    return false;
  }

  getStatusColor() {
    switch (this.model?.accomodationUnitStatus) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return ["orange-text"];
      case AccomodationUnitStatusEnum.NeedsRepair:
        return ["red-text"];
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return ["orange-text"];
      case AccomodationUnitStatusEnum.RepairInProgress:
        return ["red-text"];
      default:
        return [""];
    }
  }

  getStatusIcon() {
    switch (this.model?.accomodationUnitStatus) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return "fa-vacuum";
      case AccomodationUnitStatusEnum.NeedsRepair:
        return "fa-tools";
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return "fa-vacuum";
      case AccomodationUnitStatusEnum.RepairInProgress:
        return "fa-tools";
      default:
        return "";
    }
  }

  @Watch("reservationModel.numberOfAdults")
  numberOfAdultsChanged() {
    if (
      this.reservationModel?.numberOfUnits != null &&
      this.reservationModel.numberOfUnits <= 1 &&
      this.reservationModel?.accomodationUnitTypes.length == 1 &&
      this.reservationModel.numberOfAdults != null
    ) {
      this.reservationModel.accomodationUnitTypes[0].numberOfAdults =
        this.reservationModel.numberOfAdults;
    }
  }

  @Watch("reservationModel.numberOfChildren")
  numberOfChildrenChanged() {
    if (
      this.reservationModel?.numberOfUnits != null &&
      this.reservationModel.numberOfUnits <= 1 &&
      this.reservationModel?.accomodationUnitTypes.length == 1 &&
      this.reservationModel.numberOfChildren != null &&
      this.reservationModel.childrenAges
    ) {
      this.reservationModel.accomodationUnitTypes[0].numberOfChildren =
        this.reservationModel.numberOfChildren;
      if (
        !this.reservationModel.numberOfChildren ||
        this.reservationModel.numberOfChildren <= 0
      ) {
        this.reservationModel.accomodationUnitTypes[0].childrenAges = [];
        return;
      }

      while (
        this.reservationModel.accomodationUnitTypes[0].childrenAges.length <
        this.reservationModel.numberOfChildren
      ) {
        this.reservationModel.accomodationUnitTypes[0].childrenAges.push(0);
      }

      while (
        this.reservationModel.accomodationUnitTypes[0].childrenAges.length >
        this.reservationModel.numberOfChildren
      ) {
        this.reservationModel.accomodationUnitTypes[0].childrenAges.pop();
      }
    }
  }

  get childrenAgesValid() {
    if (this.model) {
      const result = this.model.childrenAges.every((age) => {
        return (!!age || age === 0) && age >= 0 && age % 1 == 0;
      });

      return result;
    }

    return true;
  }

  get obRatePlanFactors() {
    return {
      numberOfAdults: this.model?.numberOfAdults ?? 0,
      numberOfChildren: this.model?.numberOfChildren ?? 0,
      numberOfNights: this.numberOfNights,
    };
  }

  get hasWarning() {
    if (this.model) {
      return this.model.numberOfAdults > this.model.maxOccupancy;
    }
    return false;
  }

  @Getter("appParams/childrenAffectPAXRatePlanSelection")
  childrenAffectPAXRatePlanSelection?: boolean;

  @Watch("obRatePlanFactors", { deep: true })
  unitNumberOfAdultsChanged(
    fresh: {
      numberOfAdults: number;
      numberOfChildren: number;
      numberOfNights: number;
    },
    old?: {
      numberOfAdults: number;
      numberOfChildren: number;
      numberOfNights: number;
    }
  ) {
    if (_.isEqual(fresh, old)) {
      return;
    }
    const numberOfPeople =
      fresh.numberOfAdults +
      (this.childrenAffectPAXRatePlanSelection ? fresh.numberOfChildren : 0);
    if (
      this.model &&
      this.model.ratePlan &&
      !this.model.userSetPricePerNightManually &&
      !this.model.manuallyChangedRatePlan
    ) {
      const currentMainRatePlanId = this.model.ratePlan.id;
      let obRatePlan: RatePlanModel | undefined = undefined;
      obRatePlan = this.model.ratePlanOptions.find(
        (x) =>
          this.model &&
          x.status &&
          x.minStay <= fresh.numberOfNights &&
          (x.maxStay >= fresh.numberOfNights || x.maxStay === 0) &&
          x.minPersons <= numberOfPeople &&
          x.maxPersons >= numberOfPeople &&
          x.ratePlanId === currentMainRatePlanId
      );

      if (!obRatePlan) {
        obRatePlan = this.model.ratePlanOptions.find(
          (x) =>
            this.model &&
            x.status &&
            x.isDefault &&
            x.ratePlanId === currentMainRatePlanId
        );
      }

      if (
        obRatePlan &&
        obRatePlan.id !== this.model.ratePlan.ratePlansAccomodationUnitTypeId
      ) {
        this.changeRatePlan({
          ratePlansAccomodationUnitTypeId: obRatePlan.id,
          updateOtherUnits: false,
          autoPriceRecalculation: true,
          inputPriceRecalculationOnly:
            this.reservationModel?.isChannexIdPresent ?? false,
        });
      }
    }
  }

  changeRatePlan(event: ChangeRatePlanEvent) {
    if (this.model) {
      const ratePlan = this.model.ratePlanOptions.find(
        (x) => x.id === event.ratePlansAccomodationUnitTypeId
      );
      if (ratePlan) {
        this.model.ratePlansAccomodationUnitTypeId = ratePlan.id;
        this.model.ratePlan = {
          id: ratePlan.ratePlanId,
          ratePlansAccomodationUnitTypeId: ratePlan.id,
          name: ratePlan.name,
          parentRatePlanId: ratePlan.parentRatePlanId,
          currencyId: ratePlan.currencyId,
          accomodationBookingFee: ratePlan.accomodationBookingFee,
          addOnServicesBookingFee: ratePlan.addOnServicesBookingFee,
          mergeAllBookingFeesIntoSingleItem:
            ratePlan.mergeAllBookingFeesIntoSingleItem,
        } as SelectedRatePlanModel;
      }
    }

    this.$emit("changedRatePlan", {
      model: this.model,
      updateOtherUnits: event.updateOtherUnits,
      autoPriceRecalculation: event.autoPriceRecalculation,
      inputPriceRecalculationOnly: event.inputPriceRecalculationOnly,
    });
  }
}
